import React from 'react';
import { Link } from 'react-router-dom';
import PressBlog from '../img/press blog.jpg';

const NewsBlogs = () => {
  const articles = [
    {
      id: 1,
      title: "5 Digital Marketing Strategies Vibex Media Uses to Boost Impact for Non-Profits and Service Companies (Featuring GNI & Arvarta)",
      excerpt: "Discover how Vibex Media’s partnership-driven strategies empower organizations like GNI and Arvarta to reach larger audiences and create meaningful impact.",
      date: "October 2025",
      category: "Marketing Insights",
      image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=2070&q=80",
      readTime: "6 min read"
    },
    {
  id: 2,
  title: "How Vibex Media and VMS Labs Are Transforming Brand Storytelling with AI (Featuring GNI & Arvarta)",
  excerpt: "Discover how Vibex Media and VMS Labs are reshaping digital storytelling with AI, helping brands like GNI and Arvarta inspire audiences with data-driven creativity.",
  date: "November 2025",
  category: "AI & Branding",
  image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=2070&q=80",
  readTime: "7 min read",
},
    // {
    //   id: 3,
    //   title: "Social Media Algorithms: What Marketers Need to Know",
    //   excerpt: "Understanding platform algorithms to maximize your organic reach and engagement.",
    //   date: "April 10, 2025",
    //   category: "Social Media",
    //   image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1674&q=80",
    //   readTime: "5 min read"
    // }
  ];

  return (
    <section id="news-blogs" className="news-blogs py-5">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 text-center">
            <div className="section-title">
              <h2>News & Blogs</h2>
              <p className="text-muted">Stay updated with the latest industry insights and marketing trends</p>
            </div>
          </div>
        </div>
        
        <div className="row g-4">
          {articles.map((article) => (
            <div key={article.id} className="col-lg-4 col-md-6">
              <div className="blog-card h-100">
                <div className="blog-image">
                  <img src={article.image} alt={article.title} className="img-fluid w-100" loading="lazy" />
                  <span className="blog-category">{article.category}</span>
                </div>
                <div className="blog-content p-4">
                  <div className="blog-meta d-flex justify-content-between mb-3">
                    <span className="blog-date">{article.date}</span>
                    <span className="blog-read-time">{article.readTime}</span>
                  </div>
                  <h3 className="blog-title">{article.title}</h3>
                  <p className="blog-excerpt">{article.excerpt}</p>
                  <Link to={`/blog/${article.id}`} className="blog-read-more">
                    Read More <i className="fas fa-arrow-right ms-2"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="row mt-5">
          <div className="col-12 text-center">
            <Link to="/Blogs" className="btn btn-primary">
              View All Articles <i className="fas fa-arrow-right ms-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsBlogs;